import React from 'react';
import ReactDOM from 'react-dom';
import _ from 'lodash';

const SNACKBAR = Symbol();
const TIMER = Symbol();

const modalRoot = document.getElementById('modal-root');

class Snackbar extends React.PureComponent {

    constructor(props) {

        super(props);

        this.el = document.createElement('div');

        this.state = {

            show: props.show,
        };

        this.snackbarRef = React.createRef();
    }

    afterRender() {

        _.defer(() => {

            // Add a nice animation to show the snackbar.

            this.snackbarRef.current.classList.toggle('show', this.state.show);
        });
    }

    componentDidMount() {

        modalRoot.appendChild(this.el);
        this.afterRender();
    }

    componentDidUpdate(prevProps, prevState) {

        if (this.state.show !== prevState.show)
            this.afterRender();
    }

    componentWillUnmount() {

        modalRoot.removeChild(this.el);
    }

    hide() {

        this.setState({show: false});
    }

    render() {

        const contents = (

            <div ref={this.snackbarRef} className="snackbar">{this.props.message}</div>
        );

        return ReactDOM.createPortal(contents, this.el);
    }

    static show(props) {

        // This is very much an anti-pattern in React, but it allows for a simple and easy to use notification API.

        if (window[SNACKBAR]) ReactDOM.unmountComponentAtNode(window[SNACKBAR]);
        if (window[TIMER]) clearTimeout(window[TIMER]);

        const node = window[SNACKBAR] = document.createElement('div');
        const component = ReactDOM.render(<Snackbar show={true} {...props}/>, node, () => {

            window[TIMER] = setTimeout(() => {

                component.hide(); // The component will be hidden but not unmounted yet; that will occur when showing the next notification.

            }, props.duration || 2000);
        });
    }
}

export default Snackbar;



// WEBPACK FOOTER //
// ./src/components/Snackbar.js